import React from 'react';
import moment from 'moment';
import {
  age18,
  composeValidators,
  date,
  isValidName,
  noStartTrailWhitespace,
  required,
} from 'spa/components/form/validate';
import {
  Alpha2VatCountries,
  Alpha3ToAlpha2,
  LocalNameCountries,
} from 'spa/constants/ISOCountryCodes';
import {
  AddressFieldSet,
  DatePickerField,
  InputField,
  LocalNameFields,
  OccupationField,
  PhoneNumberInputField,
  VATFieldSet,
} from './Fields';
import Heading from './Heading';

const vatCountries = [...Alpha2VatCountries, 'EL'];

const IndividualDetailsFields = ({
  values = {},
  defaultCountry,
  lockCountry = false,
  disabled = false,
  isPersonalInformationVerified = false,
  customerFieldValues = {},
  hasSubmittedVat = false,
  occupationOptions,
  showAutocompleteAddressError,
  setShowAutocompleteAddressError,
  showHeading = true,
  showPhoneNumber = true,
  showVat = true,
  showOccupation = true,
  showLocalName = true,
}) => (
  <React.Fragment>
    {showHeading && <Heading text="Details" hasDivider />}
    <div className="kyc-inline-fields-container">
      <div className="kyc-inline-field--narrow">
        <InputField
          name="first-name"
          label="First name"
          validate={composeValidators([required, noStartTrailWhitespace, isValidName])}
          disabled={disabled || isPersonalInformationVerified}
        />
      </div>
      <div className="kyc-inline-field--narrow">
        <InputField
          name="middle-name"
          label="Middle name (Optional)"
          validate={composeValidators([noStartTrailWhitespace, isValidName])}
          disabled={disabled || isPersonalInformationVerified}
        />
      </div>
      <div className="kyc-inline-field--narrow">
        <InputField
          name="last-name"
          label="Last name"
          validate={composeValidators([required, noStartTrailWhitespace, isValidName])}
          disabled={disabled || isPersonalInformationVerified}
        />
      </div>
    </div>
    <div className="kyc-inline-fields-container">
      <div className="kyc-inline-field--half">
        <DatePickerField
          name="date-of-birth"
          label="Date of birth"
          maxDate={moment()}
          validate={composeValidators([required, age18, date])}
          disabled={disabled || isPersonalInformationVerified}
          ignoreTimezone
        />
      </div>
      {showPhoneNumber && (
        <div className="kyc-inline-field--half">
          <div className="kyc-phoneNumber">
            <PhoneNumberInputField
              name="complete-primary-phone-number"
              placeholder="Phone number"
              country={(
                values.country ||
                Alpha3ToAlpha2[customerFieldValues['primary-phone-country']] ||
                defaultCountry
              ).toLowerCase()}
              disabled={disabled}
            />
          </div>
        </div>
      )}
    </div>
    <AddressFieldSet
      type="individual"
      defaultCountry={defaultCountry}
      lockCountry={lockCountry}
      showError={showAutocompleteAddressError}
      setShowError={setShowAutocompleteAddressError}
      disabled={disabled}
    />
    {showVat && vatCountries.includes(values.country) && !hasSubmittedVat && (
      <VATFieldSet initialCountry={values.country} options={vatCountries} />
    )}
    {showOccupation && values.country === 'CA' && (
      <OccupationField isSubmitting={disabled} occupationOptions={occupationOptions} />
    )}
    {showLocalName && Object.keys(LocalNameCountries).includes(values.country) && (
      <LocalNameFields language={LocalNameCountries[values.country]} disabled={disabled} />
    )}
  </React.Fragment>
);

export default IndividualDetailsFields;
